var _style, _line, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 30",
    style: {
      enableBackground: "new 0 0 1920 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:1.5191;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:1.6663;}\n\t.st2{fill:#340000;}\n\t.st3{fill:#7E0000;}\n\t.st4{fill:#C30000;}\n\t.st5{fill:#FF0000;}\n\t.st6{fill:#C40000;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:#D9D3D3;}\n\t.st9{fill:#A6A5A5;}\n\t.st10{fill:#8D8A8A;}\n\t.st11{fill:#747373;}\n\t.st12{fill:#5F5E5E;}\n\t.st13{fill:#1B1A1A;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:1.9576;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30,
    y1: 30,
    x2: 30,
    y2: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1883,29.5V0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    className: "st2",
    width: 28,
    height: 28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    className: "st3",
    width: 28,
    height: 28
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 159.5,
    className: "st4",
    width: 28,
    height: 28
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 187.5,
    className: "st5",
    width: 28,
    height: 28
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 215.5,
    className: "st6",
    width: 28,
    height: 28
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 243.5,
    className: "st3",
    width: 28,
    height: 28
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 271.5,
    className: "st2",
    width: 28,
    height: 28
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1566,
    className: "st7",
    width: 30,
    height: 30
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1778,
    className: "st7",
    width: 30,
    height: 30
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1596,
    className: "st8",
    width: 31,
    height: 30
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1627,
    className: "st9",
    width: 30,
    height: 30
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1657,
    className: "st10",
    width: 30,
    height: 30
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1687,
    className: "st11",
    width: 30,
    height: 30
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1717,
    className: "st12",
    width: 31,
    height: 30
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1748,
    className: "st13",
    width: 30,
    height: 30
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 0,
    y1: 29,
    x2: 1920,
    y2: 29
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.502cc17dde94ceae6a860cb1d0b199dc.svg";
export { ForwardRef as ReactComponent };